import PasswordReset from "./components/PasswordReset";

export default PasswordReset